<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import modal from './modal.vue';
import {useStore} from "vuex";
import { useI18n } from "vue-i18n/index";
import ApiService from '@/core/services/ApiService';
import { Mutations } from "@/store/enums/StoreEnums";
const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const { t } = useI18n();
const user = computed(() => store.getters.currentUser);
const showPatentHakaiModal = computed(() => store.getters.getShowHakaiAchievements);
const modalRef = ref(null);
onMounted(() => {
    if (modalRef.value && showPatentHakaiModal.value) {
        modalRef.value.open();
    }
});
watch(showPatentHakaiModal, async (newVal) => {
    if (modalRef.value && newVal) {
        await modalRef.value.open();
    }
});
const markAsRead = async ()=>{
    const patent_hakai = user.value.achievements.find(a => a.type === 'patent_hakai');
    if(patent_hakai && !patent_hakai.read){
        try{
            await ApiService.put(`/achievements/${patent_hakai.id}/mark-as-read`);
            store.commit(Mutations.SET_SHOW_HAKAI_ACHIEVEMENTS, false);
        }catch(error){
            console.error("Error marking achievement as read:", error);
        }
    }else{
        store.commit(Mutations.SET_SHOW_HAKAI_ACHIEVEMENTS, false);
    }
}
const shareOnLinkedin = (userId) => {
    const url = `${process.env.VUE_APP_SHARE_URL}achievement/patent/hakai/user/${userId}`;
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
    window.open(linkedinUrl, "_blank");
};
</script>

<template>
<modal ref="modalRef" target="patent_hakai_modal">
          <template #header>
        <div>
          <div class="w-100 d-flex justify-content-end" style="position: absolute; top: 10px; right: 10px;">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" @click="markAsRead">X</button>
          </div>
          <div class="mb-12 d-flex justify-content-center">
            <img src="/media/logos/badges/hakai.png" class="avatar-img img-fluid floating" style="width: 15%;" alt="image" />
          </div>
          <h3 class="text-center" style="color:#9203DD;font-size: 24px;font-weight: bold">{{ t(`${currentLanguage}.achivement.patent_hakai.title`) }}
            <small class="bi bi-check-circle-fill text-success fs-2"></small>
          </h3>
        </div>
      </template>
      <template #body>
        <p style="font-weight: bold; text-align: center">
          {{ t(`${currentLanguage}.achivement.patent_hakai.message_1`, { user: user.nick || 'No nick' }) }}
        </p>
        <p class="text-center">
          {{ t(`${currentLanguage}.achivement.patent_hakai.message_2`) }}
        </p>

        <div class="d-flex justify-content-between">
          <div  style="width: 50%">
            <img src="/media/hc/lux_1.png" alt="image" style="width: 110% "/>
          </div>
          <div class="d-flex flex-column align-items-center justify-content-center" style="width: 50%">
            <button @click="shareOnLinkedin(user.id)" type="button" class="btn btn-primary mt-12" style="font-size: 13px">
              <span class="bi bi-linkedin" />
              {{ t(`${currentLanguage}.common.share_on_linkedin`) }}
            </button>
          </div>
        </div>
      </template>
</modal>
</template>